@if (candidates$ | async; as candidates) {
<div class="d-flex flex-column container pt-2 mt-3">
  <syn-pages-header title="Détails du groupe" subTitle="Détails du groupe" previousPage="/groups" />
  <syn-group-description-card [group]="group" [hasAssessment]="hasAssessment()" />
  @if (groupAssessments(); as groupAssessments) {
  <mat-card class="mt-3 mb-3">
    <mat-card-header>
      <mat-card-title-group>
        <mat-card-title>Évaluations</mat-card-title>
        <div>
          @if (candidates.content.length !== 0) {
          <div
            [class]="group.protected ? 'disabled-button' : ''"
            [matTooltip]="
              group.protected
                ? 'Il est impossible d\'ajouter une évaluation a un groupe automatique'
                : 'Ajouter une évaluation'
            ">
            <button class="btn btn-outline-primary btn-sm" (click)="assignAssessment()" [disabled]="group.protected">
              <span class="material-symbols-outlined pt-1">add</span>
            </button>
          </div>
          }
        </div>
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      @if (groupAssessments.content.length) {
      <div>
        <syn-group-assessments-table [groupAssessmentsPage]="groupAssessments" />
      </div>
      } @else {
      <syn-empty-page message="Ce groupe ne possède aucune évaluation" />
      }
    </mat-card-content>
  </mat-card>
  }
  <mat-card class="mt-3">
    <mat-card-header>
      <mat-card-title-group>
        <mat-card-title>Candidats</mat-card-title>
        <div class="btn-group">
          <button
            class="btn btn-outline-primary align-items-center btn-sm"
            (click)="importCandidate(group.id)"
            matTooltip="Importer des candidats">
            <span class="material-symbols-outlined pt-1"> file_upload </span>
          </button>
          <button
            [disabled]="candidates.content.length === 0"
            class="btn btn-outline-primary align-items-center btn-sm"
            (click)="sendEmailRemindCandidatesOfGroup()"
            [ngClass]="{ 'disabled-button': candidates.content.length === 0 }"
            matTooltip="Relancer les candidats">
            <span class="material-symbols-outlined pt-1">mail</span>
          </button>
          <button
            class="btn btn-outline-primary align-items-center btn-sm border-start-0"
            (click)="addCandidatesToGroup()"
            matTooltip="Ajouter un candidat au groupe">
            <span class="material-symbols-outlined pt-1">add</span>
          </button>
        </div>
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      @if (candidates.content.length) {
      <div>
        <syn-group-candidates-table
          [page]="candidates"
          [group]="group"
          [isSelectionTable]="true"
          [displayAssessment]="false" />
      </div>
      } @else {
      <syn-empty-page message="Ce groupe ne possède aucun candidat" />
      }
      <syn-pagination [page]="candidates" queryParamsHandling="merge" />
    </mat-card-content>
  </mat-card>
</div>
}
